module.exports = __webpack_public_path__ + "static/top-bg@3x-3ece7698bce2cace7371cbda56f58fc9.png";